(function () {
  var COOKIE_NAME = 'landing_url';
  var COOKIE_DAYS = 7;

  // ── Helpers ──────────────────────────────────────────────
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/' + '; SameSite=Lax';
  }

  function pushToCart(url) {
    if (!url) return;
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var existing = cart.attributes || {};

        // Already on cart with correct value — skip, no API call needed
        if (existing['landing_url'] === url) return;

        existing['landing_url'] = url;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: existing }),
        }).catch(function (err) {
          console.warn('[LandingURL] Cart update failed:', err);
        });
      })
      .catch(function (err) {
        console.warn('[LandingURL] Cart read failed:', err);
      });
  }

  // ── On page load ─────────────────────────────────────────
  var existing = getCookie(COOKIE_NAME);

  if (!existing) {
    // First visit — capture and push immediately
    var landingUrl = window.location.href;
    setCookie(COOKIE_NAME, landingUrl, COOKIE_DAYS);
    pushToCart(landingUrl);
  } else {
    // Returning visitor — wait for other apps to write first, then merge
    setTimeout(function () {
      pushToCart(existing);
    }, 1500);
  }

  // ── On Add to Cart click ──────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[name="add"], [data-add-to-cart], .add-to-cart, [id*="add-to-cart"], [class*="add_to_cart"]'
    );
    if (!btn) return;
    pushToCart(getCookie(COOKIE_NAME));
  });

  // ── On cart page — re-push as safety net ─────────────────
  if (window.location.pathname === '/cart') {
    setTimeout(function () {
      pushToCart(getCookie(COOKIE_NAME));
    }, 1000);
  }

  // ── On checkout button click ──────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '[name="checkout"], [href="/checkout"], .cart__checkout, #checkout, [data-checkout]'
    );
    if (!btn) return;
    pushToCart(getCookie(COOKIE_NAME));
  });
})();
